@if (planning) {
    <div class="container-fluid">
        <div class="row mb-3">
            <div class="col-4">
                <label>Status</label>
                {{ (statusList | byId: planning.status_key : 'key')?.name }}
            </div>
            <div class="col-4">
                <label>{{ planning.afas_project_id ? 'Project' : 'Werknummer' }}</label>
                {{ planning.afas_project_id ?? planning.worknumber }}
            </div>
            <div class="col-4">
                <label>Opdrachtgever</label>
                {{ planning.contractor }}
            </div>
            <div class="col-4">
                <label>Locatie</label>
                <div class="ellipsis">{{ planning.location }}</div>
            </div>
            <div class="col-4">
                <label>Ploeg</label>
                {{ (entities | byId: mainPlanning.entity_id)?.name }}
            </div>
            <div class="col-4">
                <label>Dumpers</label>
                @for (dumper of planning.planning_dumpers; track dumper) {
                    {{ (entities | byId: dumper.entity_id)?.name }}<br />
                }
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-4">
                <label>Datum</label>
                {{ mainPlanning.begindate | date: 'EEE d MMM y H:mm' }}<br />
                {{ mainPlanning.enddate | date: 'EEE d MMM y H:mm' }}
            </div>
            <div class="col-4">
                <label>{{ environment.executorName | ucFirst }}</label>
                {{ (planning.performer | userById)?.name }}
            </div>
            <div class="col-4">
                <label>Projectleider</label>
                {{ (planning.projectmanager | userById)?.name }}
            </div>
            <div class="col-4">
                <label>Asfaltuitvoerder</label>
                {{ (planning.asphalt_performer | userById)?.name }}
            </div>
            <div class="col-6">
                <label>Sets</label>
                @for (set of planning.planning_sets; track set; let isLast = $last) {
                    {{ (entities | byId: set.entity_id)?.name }}{{ isLast ? '' : ',' }}
                }
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="row mb-2">
                    <div class="col">
                        <label>Aantal verkeersregelaars</label>
                        {{ planning.traffic_controllers || '-' }}
                    </div>
                    <div class="col">
                        <label>Afgieten</label>
                        {{ planning.pouring_off ? 'Ja' : 'Nee' }}
                    </div>
                    <div class="col">
                        <label>Afstrooien</label>
                        {{ planning.scatter ? 'Ja' : 'Nee' }}
                    </div>
                    <div class="col">
                        <label>Kranen</label>
                        @for (crane of planning.planning_cranes; track crane) {
                            {{ (entities | byId: crane.entity_id)?.name }}<br />
                        }
                    </div>
                    <div class="col">
                        <label>Walsen</label>
                        @for (roller of planning.planning_rollers; track roller) {
                            {{ (entities | byId: roller.entity_id)?.name }}<br />
                        }
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <label>Verkeersmaatregelen</label>
                        <div class="ellipsis">{{ planning.traffic || '-' }}</div>
                    </div>
                    <div class="col">
                        <label>Asfaltlocatie</label>
                        {{ planning.asphalt_location }}
                    </div>
                    <div class="col">
                        <label>GM Asfalt overig</label>
                        @for (other of planning.planning_asphalt_others; track other) {
                            {{ (entities | byId: other.entity_id)?.name }}<br />
                        }
                    </div>
                    <div class="col">
                        <label>Kleefwagen</label>
                        @for (sticky of planning.planning_sticky_wagons; track sticky) {
                            {{ (entities | byId: sticky.entity_id)?.name }}<br />
                        }
                    </div>
                    <div class="col">
                        @if (!planning?.mainPlanning?.entity?.use_once) {
                            <label>Inhuur mensen</label>
                            {{ planning.planning_hire_people | PlanningEntitiesToString: entitiesMap }}
                        }
                    </div>
                </div>
            </div>
            <div class="col">
                <label>Omschrijving</label>
                <div [innerHTML]="planning.description | nl2br"></div>
            </div>
        </div>
        @if (viewModel.team) {
            <div>
                <h5>Asfaltleverantie</h5>
                <table class="table table-center">
                    <tr>
                        <th>Molen</th>
                        <th>Type asfalt</th>
                        <th width="130">Code centrale</th>
                        <th class="number-input">Ton</th>
                        <th class="number-input">Dikte <small>mm</small></th>
                        <th>Tijdstip</th>
                        <th class="number-input">Vrachtwagens</th>
                        <th width="250">Opmerking</th>
                    </tr>
                    @for (planningAsphalt of planning.asphalt_list; track planningAsphalt) {
                        <tr>
                            <td>
                                {{ (mills | byId: planningAsphalt.asphaltmill_id)?.name }}
                            </td>
                            <td>{{ planningAsphalt.asphaltname }}</td>
                            <td>{{ planningAsphalt.asphaltcode }}</td>
                            <td>{{ planningAsphalt.tons }}</td>
                            <td>{{ planningAsphalt.thickness }}</td>
                            <td>{{ planningAsphalt.time | date: 'H:mm' }}</td>
                            <td>{{ planningAsphalt.trucks }}</td>
                            <td>{{ planningAsphalt.comment }}</td>
                        </tr>
                    }
                </table>
            </div>
        }
        @if (viewModel.cutterList) {
            <div>
                <h5>Frezen</h5>
                <table class="table table-center">
                    <tr>
                        <th>Type</th>
                        <th>Ontvangst</th>
                        <th class="number-input">Ton</th>
                        <th class="number-input">Dikte <small>mm</small></th>
                        <th class="number-input">Vrachtwagens</th>
                        <th class="tabletime">Tijdsblok</th>
                        <th>Opmerking</th>
                    </tr>
                    @for (cutter of planning.planning_cutters; track cutter) {
                        <tr>
                            @if ((entities | byId: cutter.entity_id)?.use_once) {
                                <td>
                                    {{ (entities | byId: cutter.entity_id)?.name }}
                                </td>
                            } @else if (!(entities | byId: cutter.entity_id)?.use_once) {
                                <td>
                                    {{ cutter.name }}
                                    @if (cutter?.hiring?.name) {
                                        ({{ cutter?.hiring?.name }})
                                    }
                                </td>
                            }
                            <td>{{ cutter.location }}</td>
                            <td>{{ cutter.tons }}</td>
                            <td>{{ cutter.thickness }}</td>
                            <td>{{ cutter.trucks }}</td>
                            <td>{{ cutter.begindate | date: 'd MMM H:mm' }} - {{ cutter.enddate | date: 'H:mm' }}</td>
                            <td>{{ cutter.comment }}</td>
                        </tr>
                    }
                </table>
            </div>
        }
        @if (viewModel.wipertruckList) {
            <div>
                <h5>Veeg-/zuigwagens</h5>
                <table class="table table-center mb-0">
                    <tr>
                        <th class="wiper-selection">Type</th>
                        <th class="tabletime">Tijdsblok</th>
                        <th>Wegdekreiniger</th>
                        <th>Opmerking</th>
                    </tr>
                    @for (wipetruck of planning.planning_wipetrucks; track wipetruck) {
                        <tr>
                            @if ((entities | byId: wipetruck.entity_id)?.use_once) {
                                <td>
                                    {{ (entities | byId: wipetruck.entity_id)?.name }}
                                </td>
                            } @else if (!(entities | byId: wipetruck.entity_id)?.use_once) {
                                <td>
                                    {{ wipetruck.name }}
                                    @if (wipetruck.hiring?.name) {
                                        ({{ wipetruck?.hiring?.name }})
                                    }
                                </td>
                            }
                            <td>
                                {{ wipetruck.begindate | date: 'd MMM H:mm' }} - {{ wipetruck.enddate | date: 'H:mm' }}
                            </td>
                            <td>{{ wipetruck.wdr }}</td>
                            <td>{{ wipetruck.comment }}</td>
                        </tr>
                    }
                </table>
            </div>
        }
    </div>
}
